import type { Industry } from '../types/account';

// CLIENT PORTAL §3a — the heading over the rest of the Kyck team (2026-09-04).
//
// ⚠️⚠️ ITS OWN FILE, AND THAT IS THE POINT. `portalTeam.ts` carries an absolute
// source guard that NO INDUSTRY LITERAL APPEARS IN IT — round 9 §5's guarantee
// that the team is derived from the VIEWING CLIENT'S industry, so an automotive
// portal needs no second rule. Scott then asked for "Other Fitness Franchise
// Contacts", and a heading that maps an industry to words must NAME the
// industries, which is the one thing that file may not do.
//
// ⚠️ SO THE TWO CONCERNS ARE SPLIT RATHER THAN THE GUARD RELAXED. Excluding one
// function from a guard is how a guard stops meaning anything; moving the copy
// out keeps the derivation's rule ABSOLUTE and gives the mapping its own, weaker
// but still real, one:
//
//   · the DERIVATION (portalTeam.ts) may never name an industry — naming one
//     there is a filter, and a filter is what would put automotive account
//     managers on a Snap portal.
//   · the COPY (here) must name every industry, and can filter nothing: it is a
//     total `Industry → string` map with no access to a roster.
//
// ⚠️⚠️ A `Record<Industry, string>` RATHER THAN A SWITCH, deliberately: a fifth
// industry becomes a COMPILE ERROR here instead of falling silently to a default
// that would be wrong for it. The same compile-error pattern the report's axis
// types and `PortalScope` use.

/**
 * ⚠️ The wording per industry. Scott's exact words for fitness, which is the
 * case he is looking at; the same shape carries automotive.
 *
 * ⚠️ SENTENCE CASE (rule 11). It renders in the caps mono micro-label style,
 * which is the one place capitals are permitted — baking them into the string
 * would carry them into anywhere else this copy is ever reused.
 */
const HEADING_BY_INDUSTRY: Record<Industry, string> = {
  fitness_franchise: 'Other fitness franchise contacts',
  automotive_franchise: 'Other automotive contacts',
  small_business_ecommerce: 'Other Kyck contacts',
  other: 'Other Kyck contacts',
};

/** ⚠️ Used for a mixed or empty scope — see below. */
const NEUTRAL_HEADING = 'Other Kyck contacts';

/**
 * The heading over the team list.
 *
 * ⚠️⚠️ IT TAKES THE INDUSTRIES THE LIST WAS BUILT FROM, never a second lookup.
 * That is what makes it impossible for the heading to name a different industry
 * from the people beneath it — the browser receives the exact array the server
 * filtered by, and this is a function of it.
 *
 * ⚠️⚠️ A MIXED SCOPE FALLS BACK TO THE NEUTRAL WORDING RATHER THAN PICKING ONE.
 * A group spanning fitness and automotive has no single true adjective, and
 * choosing one would be wrong for half the list. Same reasoning as
 * `singleBrandOrNull` returning null rather than the first brand, and as
 * `scopeIndustries` returning the union rather than the first account's.
 */
export function teamHeading(industries: readonly Industry[]): string {
  if (industries.length !== 1) return NEUTRAL_HEADING;
  return HEADING_BY_INDUSTRY[industries[0] as Industry];
}
